export default __webpack_public_path__ + "static/media/Shadow's Jerkin of the Swift Return.aef84693.jpg";